<template>
  <div :class="$attrs.class">
    <div class="tw-flex tw-grow tw-items-center tw-flex-row md:tw-flex-col xl:tw-flex-row 2xl:tw-flex-col tw-overflow-hidden md:tw-rounded-3xl xl:rounded-none 2xl:tw-rounded-3xl md:tw-shadow-lg xl:tw-shadow-none 2x:tw-shadow-lg tw-bg-white tw-group tw-w-full tw-items-center tw-relative">

      <div class="tw-absolute tw-top-2 tw-right-2 tw-z-10 tw-rounded-full tw-px-4 tw-text-white tw-bg-orange-medium hover:tw-bg-black tw-transition-all tw-duration-300 tw-cursor-pointer tw--translate-x-px" v-if="assistanceLevel <= 3" @click="handleDetails" aria-label="More Details">
        <span class="tw-text-2xl fa fa-info"></span>
      </div>

      <div class="tw-overflow-hidden tw-block md:tw-h-auto tw-w-40 md:tw-w-full xl:tw-w-40 2xl:tw-w-full tw-relative tw-grow-0 xl:tw-grow-1 2xl:tw-grow-0 tw-shrink-0 xl:tw-shrink-1 2xl:tw-shrink-0">

        <div class="tw-absolute tw-top-0 tw-bottom-0 tw-left-0 tw-right-0 tw-flex tw-items-center tw-justify-center tw-z-10" v-if="props.addingProduct">
          <span class="fa fa-spinner tw-text-black tw-inline-block tw-animate-spin tw-ease tw-duration-300 tw-text-5xl"></span>
        </div>

        <img 
          :alt="product.name+' image'"
          :class="['tw-scale-105 md:tw-h-full tw-w-full group-hover:tw-scale-110 tw-transition-all tw-duration-300 tw-ease-out', {'tw-opacity-40': props.addingProduct}]"
          :src="productImage">
      </div>
      
      <div :class="['tw-px-8 tw-pt-4 tw-pb-4 tw-grow tw-justify-between md:tw-pt-8 md:tw-pb-8 xl:tw-pt-4 xl:tw-pb-4 2xl:tw-pt-8 2xl:tw-pb-8 md:tw-text-center xl:tw-text-left 2xl:tw-text-center tw-font-black tw-w-full tw-flex tw-flex-col', {'tw-text-gray-400': props.addingProduct}]">
        <div>
          {{product.name}}
          <div :class="['md:tw-text-center xl:tw-text-left 2xl:tw-text-center tw-font-normal', {'tw-text-gray-400': props.addingProduct}]">
            <div class="tw-mb-0">${{productPrice}}</div>
          </div>
          <div :class="['2xl:tw-text-center tw-font-normal tw-w-full tw-block tw-text-xl']" v-if="assistanceLevel > 3">
            <div class="tw-my-2 tw-cursor-pointer tw-underline hover:tw-text-orange-medium" @click="handleDetails">More Details</div>
          </div>
        </div>

        <!-- <div>
        </div> -->
        
        <div class="tw-mt-4">
          <div class="tw-flex-initial tw-flex tw-justify-start md:tw-justify-center xl:tw-justify-start 2xl:tw-justify-center tw-mb-3">
            <div class="tw-input-group-wrapper tw-flex tw-flex-1 tw-items-center tw-relative tw-max-w-xs lg:tw-max-w-[15rem] xl:tw-w-full tw-text-xl lg:tw-text-3xl xl:tw-text-xl 2xl:tw-text-3xl tw-text-center lg:tw-px-16 tw-py-2 tw-border focus:tw-outline-none tw-border-gray-400 focus:tw-border-orange-medium tw-rounded-l-full">
              <input 
              v-model="localQuantity"
              min="1"
              increment="1"
              :disabled="props.addingProduct"
              class="tw-bg-transparent focus:tw-outline-none focus:tw-ring-0 tw-w-full tw-text-xl lg:tw-text-3xl xl:tw-text-xl 2xl:tw-text-3xl tw-border-0 tw-text-center"
              type="number">
              <button
                @click="decrementQuantity"
                class="tw-px-8 tw-text-4xl hover:tw-text-orange-medium tw-transition-all tw-font-bold tw-text-black tw-absolute tw-left-0">
                &mdash;
              </button>

              <button
                @click="incrementQuantity"
                class="tw-px-8 tw-text-4xl hover:tw-text-orange-medium tw-transition-all tw-font-bold tw-text-black tw-absolute tw-right-0 ">
                +
              </button>
            </div>

            <TwButton
              cssClass="tw-input-group-btn tw-ml-0 tw-bg-orange-medium tw-border-2 tw-border-orange-medium tw-text-white tw-text-lg 2xl:tw-text-2xl hover:tw-bg-black hover:tw-border-black tw-uppercase tw-font-bold tw-px-8 2xl:tw-px-12 tw-py-2 2xl:tw-py-3 tw-transition-all tw-duration-200 tw-rounded-r-full"
              @click="handleClick"
              :isLoading="props.addingProduct"
              :buttonText="(buttonPath == 'customize' ? 'Customize' : 'Add to Bag')" />
          </div>

          <TwButton
              cssClass="tw-external-input-btn tw-ml-0 md:tw-mr-auto md:tw-ml-auto xl:tw-mr-auto xl:tw-ml-0 2xl:tw-mr-auto 2xl:tw-ml-auto tw-bg-orange-medium tw-border-2 tw-border-orange-medium tw-text-white tw-text-lg 2xl:tw-text-2xl hover:tw-bg-black hover:tw-border-black tw-uppercase tw-font-bold tw-px-8 2xl:tw-px-20 tw-py-3 2xl:tw-py-4 tw-transition-all tw-duration-200 tw-rounded-full"
              @click="handleClick"
              :isLoading="props.addingProduct"
              :buttonText="(buttonPath == 'customize' ? 'Customize' : 'Add to Bag')" />
        </div>

      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
  import { ref, onMounted, computed, watch } from 'vue'
  import { useRouter } from 'vue-router'
  import type Product from '../../classes/Product';

  const props = defineProps<{ product: Product, addingProduct: boolean, assistanceLevel: number, quantity: number }>();
  import TwButton from '../../components/TwButton.vue';

  const productImage = ref();
  const localQuantity = ref(1);

  const router = useRouter();

  const emit = defineEmits(['handleProductAdd', 'handleDetailsModal'])

  onMounted(() => {
    if (props.product != null && props.product.images) {
      let img = props.product.getImageByKey("product_web_category")

      if (img) {
        productImage.value = img.url
      } else {
        productImage.value = 'https://mypiada-assets.s3.amazonaws.com/static_assets/scooter-placeholder.jpg';
      }

      if (props.quantity) {
        localQuantity.value = props.quantity;
      }
    }
  })

  watch(() => props.quantity, (newVal, oldVal) => {
    if (newVal != oldVal && newVal != localQuantity.value) {
      localQuantity.value = newVal;
    }
  });

  const buttonPath = computed(() => {
    let path = "customize"
    
    if (props.product != null && props.product.metadata != null) {
      if (props.product.getMetaDataByKey("modifiable") != null && props.product.getMetaDataByKey("modifiable") == false) {
        path = "addToBag"
      } else if (props.product.getMetaDataByKey("buttonPath") && props.product.getMetaDataByKey("buttonPath") != "customize") {

      }
    }

    return path;
  })

  const productPrice = computed(() => {
    let total = props.product.priceWithDefaults();

    if (buttonPath.value == 'addToBag') {
      total = total * localQuantity.value;
    }

    return total.toLocaleString("en-US", {minimumFractionDigits: 2})
  })

  const decrementQuantity = () => {
    if (!props.addingProduct){
      localQuantity.value = Math.max(localQuantity.value -= 1, 1);
    }
  };

  const incrementQuantity = () => {
    if (!props.addingProduct){
      localQuantity.value = Math.min(localQuantity.value += 1, 99);
    }
  };

  const handleDetails = (event: Event) => {
    props.product.quantity = localQuantity.value;
    emit('handleDetailsModal', props.product)
  }

  const handleClick = (event: Event) => {
    if (buttonPath.value == "customize") {
      if (localQuantity.value && localQuantity.value != 1) {
        router.push({ name: 'product', params: { id: props.product.id}, query: { quantity: localQuantity.value!.toString() }})
      } else {
        router.push({ name: 'product', params: { id: props.product.id}})
      }
    } else if (buttonPath.value == "addToBag" && !props.addingProduct) {
      props.product.quantity = localQuantity.value;
      emit('handleProductAdd', props.product)
    }
  }

</script>

<style scoped>
  .tw-external-input-btn {
    display: none;
  }

  @media screen and (min-width: 1536px) and (max-width:1920px) {
    .tw-external-input-btn {
      display: inline-block;
    }

    .tw-input-group-btn {
      display: none;
    }

    .tw-input-group-wrapper {
      border-top-right-radius: 9999px;
      border-bottom-right-radius: 9999px;
      margin-left: 15px;
      margin-right: 15px;
    }
  }

  .catering--flex-row-wrapper {
    display: flex;
    align-items: center;
  }

  @media screen and (min-width: 768px) {
    .catering--flex-row-wrapper {
      display: block;
    }
  }
</style>
